export const SITE = {
  name: "JAYTRIKA",
  tagline: "Connecting Today. Building Tomorrow.",
  footerTagline: "Connecting Networks. Powering Infrastructure.",
  email: "info@jaytrika.in",
  phoneDisplay: "+91 93912 89414",
  phoneHref: "tel:+919391289414",
  whatsapp: "919391289414",
  address: "Manikonda, Hyderabad, Telangana, India",
  mapEmbed:
    "https://www.google.com/maps?q=Manikonda,%20Hyderabad,%20Telangana&output=embed",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const REQUIREMENTS = [
  "OFC / Optical Fiber Cables",
  "Networking Equipment",
  "Optical Components & SFPs",
  "Power & Backup Solutions",
  "Office & IT Equipment",
  "Underground / Aerial OFC Laying",
  "Fiber Lease / Rental",
  "Dark Fiber",
  "Co-location",
  "RF Links",
  "Fiber Shifting / Relocation",
  "Other",
];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export async function submitEnquiry(payload) {
  const res = await fetch(`${API}/enquiries`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("Enquiry submission failed");
  return res.json();
}
